import React from 'react'

import { VerticalTimeline }  from 'react-vertical-timeline-component';
import { motion } from 'framer-motion'
import { experiences } from '../data/alldata';
import ExperienceCard from './Item/ExperienceCard';
import StarsCanvas from '../3d/Stars';

const fadeIn = (direction = "", type = "spring", delay = 0.1, duration = 1) => {
    return {
      hidden: { opacity: 0 },
      visible: { opacity: 1, transition: { delay, duration } },
    };
  };


const Works = ({theme}) => {
   
  return (

    <div
    className="relative w-full h-auto mx-auto  bg-center"
id='work'
>

  

 <motion.p
 initial={{opacity:0.2,y:50}}
 transition={{duration:1}}
 whileInView={{opacity:1,y:0}}
 viewport={{once:true}}
  className="mt-4 text-gray-600 text-[20px] max-w-3xl leading-relaxed text-center mx-auto"
>
<h2 className="text-black text-[69px] font-bold">Work  <span className="text-[#fff000]"> Experience</span></h2>

See my most recent projects below to get an idea of my past experience.

</motion.p>

   
    
    <div className="mt-20  flex flex-col">
   
    
      <VerticalTimeline>
        

      {experiences.map((experience,index)=>(
        <ExperienceCard key={index} experience={experience} />
        
      ))}
      </VerticalTimeline>

    </div>
   
   </div>
  )
}

export default Works